import React from 'react'
import { connect } from 'react-redux'
import DataPanel from 'components/theme/DataPanel'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({
		stats:
			state.signupForm.addOrEdit.formTypeSelected === 'custom'
				? state.data?.customform?.[state.signupForm.addOrEdit.formID]?.stats
				: state.signupForm.forms?.[state.signupForm.addOrEdit.formID]?.stats,
		internal_type:
			state.data?.customform?.[state.signupForm.addOrEdit.formID]
				?.internal_type,
	}),
	null,
)(({ stats, internal_type }) =>
	stats ? (
		internal_type === 'ci1' ? (
			<div style={{ marginTop: 12, marginBottom: 12 }}>
				<DataPanel
					color="green"
					value={stats?.submissions}
					label={`${language.signupform.add.responses.totalResponses}`}
				/>
			</div>
		) : (
			<div style={{ marginTop: 12, marginBottom: 12 }}>
				<div style={{ display: 'inline-block', width: '50%', paddingRight: 6 }}>
					<DataPanel
						color="green"
						value={
							stats && stats.visits > 0
								? `${Math.round((stats.submissions / stats.visits) * 100)}%`
								: '--%'
						}
						label={`${stats ? stats.submissions : '0'} ${
							language.signupform.add.responses.totalResponses
						}`}
					/>
				</div>
				<div style={{ display: 'inline-block', width: '50%', paddingLeft: 6 }}>
					<DataPanel
						color="orange"
						value={stats ? stats.visits : '0'}
						label={language.signupform.add.responses.totalVisits}
					/>
				</div>
			</div>
		)
	) : null,
)
